module.exports = __webpack_public_path__ + "media/images/common/cart_btn_ov-2827a987b8184f8a296913aaa664051c.png";